import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';
import Catalog from './Catalog';

class ListCatalogs extends React.Component {
    state = {
        catalogs: [
            {
                codigo: 'familiaproducto',
                nombre: this.props.intl.formatMessage({ id: 'familiaproducto' }),
            },
            {
                codigo: 'unidadmedida',
                nombre: this.props.intl.formatMessage({ id: 'unidadmedida' }),
            },
            {
                codigo: 'estacion',
                nombre: this.props.intl.formatMessage({ id: 'estacion' }),
            },
        ],
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    render() {
        const { catalogs } = this.state;
        return (
            <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                    {catalogs.map((u) => {
                        return <Catalog key={randomstring()} catalog={u} />;
                    })}
                </div>
            </div>
        );
    }
}
Catalog.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ListCatalogs);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/catalogs/List.js